module.exports = __webpack_public_path__ + "assets/img/9c31-kz.svg";